import React from 'react'
import clsx from 'clsx'
import Drawer from '@material-ui/core/Drawer'
import IconButton from '@material-ui/core/IconButton'
import { ReactComponent as IconArrowLeft } from 'assets/icons/arrow-left.svg'
import { ReactComponent as IconArrowRight } from 'assets/icons/arrow-right.svg'
import Menu from 'ui/modules/menu'
import SvgIcon from '@material-ui/core/SvgIcon'
import useStyles from './styles'

const Sidebar = props => {
  const { open, setOpen, user, onLogout } = props
  const classes = useStyles()
  const handleToggleDrawer = () => {
    setOpen(!open)
  }
  return (
    <Drawer
      variant="permanent"
      onClose={handleToggleDrawer}
      classes={{
        paper: clsx(
          classes.sidebar,
          !open && classes.sidebarClose,
          !user && classes.sidebarLanding,
        ),
      }}
      open={open}
    >
      <div className={classes.sidebarHeader}>
        <IconButton
          className={classes.sidebarButton}
          aria-label="open / close drawer"
          onClick={handleToggleDrawer}
        >
          {open ? (
            <SvgIcon component={IconArrowLeft} />
          ) : (
            <SvgIcon component={IconArrowRight} />
          )}
        </IconButton>
      </div>
      <Menu open={open} user={user} onLogout={onLogout} />
    </Drawer>
  )
}

export default Sidebar
